import styled from "styled-components";
import tw from "twin.macro";
import GradientButton from "../../../../components/GradientButton";
import { COLORS } from "../theme";

const SectionSeven = styled.section`
  ${tw`relative flex items-end`}
  z-index: 1;
  min-height: 72vh;
  background: #fff;
  overflow: hidden;

  @media (max-width: 767px) {
    display: block;
    min-height: 0;
    overflow: visible;
  }
`;

const SectionSevenInner = styled.div`
  ${tw`mx-auto`}
  width: 100%;
  max-width: 1440px;
  padding: 2.6rem var(--app-content-gutter) 0;

  @media (min-width: 1024px) {
    padding-top: 2.5rem;
  }

  @media (max-width: 767px) {
    padding: 4.6rem 18px 0;
  }
`;

const SectionSevenGrid = styled.div`
  ${tw`grid items-center gap-10`}

  @media (min-width: 1024px) {
    grid-template-columns: minmax(0, 0.94fr) minmax(0, 1.06fr);
    column-gap: 2.5rem;
  }

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
`;

const SectionSevenCopy = styled.div`
  max-width: 520px;
  padding-top: 0;

  @media (min-width: 1024px) {
    margin: 0 auto;
  }

  @media (max-width: 1180px) {
    padding-top: 2.75rem;
  }

  @media (max-width: 767px) {
    max-width: 100%;
    padding-top: 0;
  }
`;

const SectionSevenTitle = styled.h3`
  margin: 0;
  font-family: "Montserrat", sans-serif;
  font-size: 36px;
  line-height: 1;
  font-weight: 700;
  color: #437672;
  text-transform: uppercase;
  text-align: right;

  @media (max-width: 767px) {
    font-size: 30px;
    text-align: center;
  }
`;

const SectionSevenLead = styled.p`
  margin: 0.85rem 0 0;
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
  line-height: 1.12;
  font-weight: 400;
  color: #4d4b4b;
  text-transform: uppercase;
  text-align: right;

  strong {
    color: ${COLORS.orange};
    font-weight: 700;
  }

  @media (max-width: 767px) {
    margin-top: 1.85rem;
    font-size: 14px;
    line-height: 1.15;
    text-align: center;
  }
`;

const SectionSevenBody = styled.p`
  margin: 1rem auto 0;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  line-height: 1.18;
  font-weight: 400;
  color: #4d4b4b;
  text-align: right;
  text-transform: uppercase;

  strong {
    font-weight: 700;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;

const SectionSevenTech = styled.p`
  margin: 1.35rem 0 0;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  line-height: 1.08;
  font-weight: 700;
  color: #437672;
  text-transform: uppercase;
  text-align: right;

  @media (max-width: 767px) {
    display: none;
  }
`;

const SectionSevenBenefit = styled.p`
  margin: 0.95rem 0 0;
  font-family: "Montserrat", sans-serif;
  font-size: 24px;
  line-height: 1.08;
  font-weight: 400;
  color: #4d4b4b;
  text-transform: uppercase;
  text-align: right;

  strong {
    color: ${COLORS.orange};
    font-weight: 700;
  }
`;

export const SectionButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 1180px) {
    justify-content: center;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;

const SectionSevenCta = styled(GradientButton).attrs({
  as: "button",
  $variant: "teal",
})`
  margin-top: 1.45rem;
  margin-left: auto;
  max-width: 100%;
  padding: 12px 30px;
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  line-height: 1.1;
  height: 48px;

  @media (max-width: 1180px) {
    margin-left: 0;
    min-width: 0;
    width: 100%;
  }

  @media (max-width: 767px) {
    height: 42px;
    padding: 9px 18px;
    font-size: 12px;
  }
`;

const SectionSevenVisual = styled.div`
  ${tw`relative`}
  min-height: 520px;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  &::after {
    content: "";
    position: absolute;
    left: 92%;
    right: 0;
    top: -80px;
    transform: translateX(-50%);
    width: 760px;
    height: 940px;
    background-image: url("/novas-imagens/section-seven/expiral.png");
    background-repeat: no-repeat;
    background-size: contain;
    pointer-events: none;
    z-index: 0;
  }

  @media (max-width: 1180px) {
    min-height: 500px;

    &::after {
      width: 620px;
      height: 768px;
      left: 86%;
      top: -64px;
    }
  }

  @media (max-width: 767px) {
    width: 100%;
    min-height: 0;
    height: 310px;
    margin-top: -0.45rem;
    overflow: hidden;
    border-radius: 0 0 22px 22px;
    background-image: url("/novas-imagens/section-seven/rectangle.png");
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: 100% 230px;
    display: block;

    &::after {
      display: none;
    }
  }
`;

const SectionSevenTrati = styled.img`
  position: absolute;
  z-index: 1;
  left: 44%;
  bottom: 0;
  transform: translateX(-50%);
  width: 276px;
  height: 380px;
  display: block;

  @media (max-width: 1180px) {
    left: 43%;
    bottom: 0;
    transform: translateX(-50%);
    width: min(38vw, 230px);
  }

  @media (max-width: 767px) {
    position: absolute;
    right: 0.35rem;
    bottom: -0.15rem;
    left: auto;
    transform: none;
    width: min(48vw, 210px);
    height: auto;
  }
`;

const SectionSevenLogo = styled.img`
  position: absolute;
  z-index: 1;
  left: 50%;
  top: 7rem;
  transform: translateX(98%);
  width: 120px;
  height: auto;

  @media (max-width: 1180px) {
    top: 3.2rem;
    transform: translateX(84%);
    width: 100px;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;

const SectionSevenMobileTech = styled.p`
  display: none;

  @media (max-width: 767px) {
    display: block;
    position: absolute;
    z-index: 2;
    left: 19%;
    top: 46%;
    margin: 0;
    max-width: 150px;
    font-family: "Montserrat", sans-serif;
    font-size: 14px;
    line-height: 1.08;
    font-weight: 700;
    color: #437672;
    text-transform: uppercase;
    text-align: left;
  }
`;

const SectionSevenMobileBody = styled.p`
  display: none;

  @media (max-width: 767px) {
    display: block;
    margin: 2rem auto 0;
    max-width: 560px;
    font-family: "Montserrat", sans-serif;
    font-size: 14px;
    line-height: 1.28;
    font-weight: 400;
    color: #4d4b4b;
    text-align: center;
    text-transform: uppercase;
  }
`;

const SectionSevenMobileButton = styled.div`
  display: none;

  @media (max-width: 767px) {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 1.65rem;
  }
`;

export {
  SectionSeven,
  SectionSevenInner,
  SectionSevenGrid,
  SectionSevenCopy,
  SectionSevenTitle,
  SectionSevenLead,
  SectionSevenBody,
  SectionSevenTech,
  SectionSevenMobileTech,
  SectionSevenMobileBody,
  SectionSevenMobileButton,
  SectionSevenBenefit,
  SectionSevenCta,
  SectionSevenVisual,
  SectionSevenTrati,
  SectionSevenLogo,
};
